module.exports = __webpack_public_path__ + "img/login.95987dd9.png";